import { action } from '@redux-src/action';
import { simpleAction } from '@redux-src/utils';
import * as TYPES from './types';

const DEFAULT_LOADING_MESSAGE = 'Loading';

/**
 * Loading action
 */
export const loadingAction = simpleAction<boolean | { message: string; loading: boolean }>(TYPES.PAGE_LOADING, true);

/**
 * Loaded action
 */
export const loadedAction = simpleAction<boolean | { message: string; loading: boolean }>(TYPES.PAGE_LOADING, false);

/**
 * Quick _loading actions
 * @param message
 * @returns {*}
 */
export const loading = (message: string = DEFAULT_LOADING_MESSAGE) =>
    action(
        loadingAction({
            message,
            loading: true,
        }),
    );

/**
 * Quick loaded actions
 * @param message
 * @returns {*}
 */
export const loaded = (message: string = DEFAULT_LOADING_MESSAGE) =>
    action(
        loadedAction({
            message,
            loading: false,
        }),
    );

/**
 * It will help you to show Loading state while the async request it's running
 * @param requestFunc
 * @param auto
 * @returns {Promise<*>}
 */
export const loadingRequest = async (
    requestFunc: (api: { loading: typeof loading; loaded: typeof loaded }) => Promise<any>,
    auto = true,
) => {
    if (auto) {
        loading();
    }

    const response = await requestFunc({ loading, loaded });

    if (auto) {
        loaded();
    }

    return response;
};
